'use strict';

const Marionette = require('backbone.marionette');

const propsMixin = module.exports = {
    setProps: function (key, value, options) {
        const me = this;
        return me.dashboardModel.setProps(key, value, options);
    },
    getProps: function () {
        const me = this;
        return me.dashboardModel.getProps();
    },
    getProp: function (prop) {
        const me = this;
        return me.dashboardModel.getProp(prop);
    },
    beforeConstruction: function (options) {
        const me = this;
        // Must be set before other construction b/c it could be relied
        // on during Marionette setup
        me.dashboardModel = options.dashboardModel;
    },
    afterConstruction: function () {
        const me = this;
        // Must be set after construction b/c all bound methods must
        // exist
        Marionette.bindEntityEvents(me, me.dashboardModel, me.dashboardModelEvents);
    }
};

propsMixin.mixin = function (View) {
    return View.mixin({
        mixins: {
            props: propsMixin
        }
    });
};
